import {
  ImageUrlBuilder,
  ImageCompressionEnum,
  ImageFormatEnum
} from 'kentico-cloud-delivery/_commonjs/';
import { isMobile } from 'react-device-detect';
import supportsWebP from 'supports-webp';
import { IMAGE_OPTIMIZATION_QUERIES } from 'common/consts/media-query';

class OptimizeImagesService {
  devicePixelRatio = window.devicePixelRatio || 2;

  mobilesBreakpoints = [Object.values(IMAGE_OPTIMIZATION_QUERIES.MOBILE)].sort(
    (a, b) => a - b
  );

  desktopBreakpoints = [Object.values(IMAGE_OPTIMIZATION_QUERIES.DESKTOP)].sort(
    (a, b) => a - b
  );

  adjustImageSize = url => {
    const urlBuilder = new ImageUrlBuilder(url);

    if (isMobile) {
      this.buildURL(this.mobilesBreakpoints, urlBuilder);
    } else {
      this.buildURL(this.desktopBreakpoints, urlBuilder);
    }

    return urlBuilder.getUrl();
  };

  buildURL = (breakpoints, urlBuilder) => {
    const getBreakpoint = breakpoints.find(
      breakpoint => window.innerWidth <= breakpoint
    );

    urlBuilder.withDpr(this.devicePixelRatio);

    if (getBreakpoint) {
      urlBuilder.withWidth(getBreakpoint);
    }

    if (supportsWebP) {
      urlBuilder
        .withFormat(ImageFormatEnum.Webp)
        .withCompression(ImageCompressionEnum.Lossy);
    }
  };
}

export default new OptimizeImagesService();



// WEBPACK FOOTER //
// ./src/services/OptimizeImages.service.js